import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group transition-opacity'
  },
  variants: {
    fixed: {
      true: {
        base: 'shadow-header'
      }
    },
    positioning: {
      sticky: {
        base: 'sticky top-0'
      },
      fixed: {
        base: 'fixed right-0 left-0'
      }
    },
    isHidden: {
      true: {
        base: ''
      }
    },
    type: {
      base: '',
      filters: {
        base: ''
      }
    },
    scrollToTop: {
      true: '',
      false: ''
    }
  },
  defaultVariants: {
    fixed: false
  },
  compoundVariants: [
    {
      type: 'base',
      positioning: 'sticky',
      className: {
        base: '!z-30 max-md:opacity-100'
      }
    },
    {
      type: 'filters',
      fixed: false,
      className: {
        base: '!z-20'
      }
    },
    {
      type: 'filters',
      fixed: true,
      className: {
        base: 'border-b-bg-items-secondary !z-45 border-b bg-white shadow-none'
      }
    },
    {
      type: 'filters',
      fixed: true,
      scrollToTop: false,
      className: {
        base: 'max-md:opacity-0'
      }
    }
  ]
});
